import { React, useState, useRef } from 'react'
import styled from 'styled-components'
import moneyImg from '../../assets/dollarLogo.png'
import CO2Img from '../../assets/CO2.png'
import trashImg from '../../assets/trash.png'
import colors from '../../styles/colors'

export default function ItemImpact({ item, backgroundColor }) {
    const [impactInfoIsVisible, setImpactInfoIsVisible] = useState(false)

    const StyledItemImpactOverallContainer = styled.div`
        position: relative;
    `

    const StyledItemPriceAndImpact = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 100%;
    `

    const StyledItemPrice = styled.div`
        font-size: 130%;
        font-weight: bold;
        padding: 2px 5px;
        display: flex;
        justify-content: center;
    `

    const StyledItemImpactContainer = styled.div`
        position: relative;
        display: inline-block;
        display: flex;
        flex-direction: column;
        font-size: 80%;
    `
    const StyledInfo = styled.div`
        position: absolute;
        background-color: #1b3e81;
        color: white;
        top: -0.5vh;
        right: -0.5vh;
        height: 2vh;
        width: 2vh;
        border-radius: 2vh;
        text-align: center;
        font-weight: bold;
        cursor: pointer; /* Ajout de curseur pointer pour le visuel */
    `

    const StyledImpactExplanation = styled.div`
        position: absolute;
        top: -50px;
        right: 30px;
        width: 350px;
        font-size: 80%;
        background-color: ${colors.second};
        border-radius: 2vh;
        border-style: solid;
        border-width: 2px;
        box-shadow: 0 0 30px grey;
        color: white;
        padding: 15px;
        z-index: 9999;
        visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
        p img {
            width: 20px;
        }
    `

    const StyledImg = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        img {
            height: 15px;
            object-fit: scale-down;
        }
    `
    const StyledValues = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 0 2px;
    `
    const StyledUnits = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    `
    const StyledItemImpact = styled.div`
        display: flex;
        justify-content: space-between;
        height: 70px;
        width: 130px;
        border-radius: 20px 0 20px 0;
        background-color: ${(props) => props.backgroundColor || '#ffffff24'};
        color: white;
        padding: 10px;
        font-size: 100%;
    `

    const timeoutRef = useRef(null)

    const handleMouseEnter = () => {
        // Active impactInfoIsVisible
        setImpactInfoIsVisible(true)

        // Définit un timeout pour le désactiver après 5 secondes
        timeoutRef.current = setTimeout(() => {
            setImpactInfoIsVisible(false)
        }, 3000)
    }

    const handleMouseLeave = () => {
        // Désactive impactInfoIsVisible immédiatement et annule le timeout
        setImpactInfoIsVisible(false)
        clearTimeout(timeoutRef.current)
    }

    let itemDiscount

    if (item.price && item.impactMoney) {
        itemDiscount =
            (item.price / (item.price + Number(item.impactMoney)) - 1) * 100
    }

    return (
        <StyledItemImpactOverallContainer>
            <StyledItemPriceAndImpact>
                <StyledItemImpactContainer>
                    <StyledInfo
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        i
                    </StyledInfo>

                    <StyledItemImpact backgroundColor={backgroundColor}>
                        <StyledImg>
                            <img src={moneyImg} alt="money" />
                            <img src={CO2Img} alt="CO2" />
                            <img src={trashImg} alt="trash" />
                        </StyledImg>
                        <StyledValues>
                            <div>+&nbsp;{item.impactMoney || 0}</div>
                            <div>-&nbsp;{item.impactCO2 || 0}</div>
                            <div>-&nbsp;{item.impactTrash || 0}</div>
                        </StyledValues>
                        <StyledUnits>
                            <div>CHF</div>
                            <div>kg</div>
                            <div>kg</div>
                        </StyledUnits>
                    </StyledItemImpact>
                </StyledItemImpactContainer>
            </StyledItemPriceAndImpact>
            <StyledImpactExplanation isVisible={impactInfoIsVisible}>
                <p>
                    Impact moyen d'acheter sur <b>Salveat</b> plutôt qu'un
                    produit neuf:
                    <br />· <strong>{item.impactMoney} CHF</strong> d'économisé
                    (<strong>{itemDiscount.toFixed(0)}%</strong> de réduction)
                    <br />· <strong>{item.impactCO2} kg</strong> de CO2 non
                    relâché
                    <br />· <strong>{item.impactTrash} kg</strong> de déchet en
                    moins
                    <br />
                    <br />
                    La planète, et votre portefeuille, vous remercient. ❤️
                </p>
            </StyledImpactExplanation>
        </StyledItemImpactOverallContainer>
    )
}
